(function () {
  'use strict';

  if (window.YarnMotion) return;

  const root = document.documentElement;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const editor = !!(window.Shopify && window.Shopify.designMode);
  const legacy = '[data-reveal], [data-reveal-media], [data-reveal-card], [data-yts-reveal], [data-yts-reveal-media], [data-yts-reveal-card], [data-yhs-reveal], [data-yhs-reveal-media], [data-ygc-reveal], [data-ygc-reveal-media], [data-yvs-reveal], [data-yvs-reveal-media], [data-yfaq-reveal], [data-yfaq-reveal-group], [data-ybl-reveal], [data-ybl-reveal-card], [data-ynl-reveal], [data-ynl-reveal-media], [data-yrt-reveal]';
  const drawerTargets = '.cart-drawer__title-wrap, .cd-ship, .cd-empty, .cd-item, .cd-upsell, .cd-note, .cd-footer__row, .cd-footer__note, .cd-checkout';
  let lenis;
  let aosReady = false;
  let refreshFrame = 0;
  let drawerFrame = 0;

  function mark(element, animation, delay) {
    if (!element || element.hasAttribute('data-aos') || element.closest('[data-motion-item]')) return;
    element.setAttribute('data-motion-item', '');
    element.setAttribute('data-aos', animation || 'fade-up');
    element.style.setProperty('--motion-delay', (delay || 0) + 'ms');
  }

  function prepareSections() {
    const content = document.querySelector('#content.index-page, #content.collection-page, #content.product-page');
    if (!content) return;
    content.querySelectorAll('.shopify-section').forEach(function (section) {
      section.querySelectorAll(legacy).forEach(function (element, index) {
        const media = Array.from(element.attributes).some(function (attr) { return /reveal-media$/.test(attr.name); });
        mark(element, media ? 'zoom-in' : 'fade-up', Math.min(index % 5, 3) * 50);
      });
      section.querySelectorAll('.ycg-header, .ycs-header, .ypc-header, .ypr-heading, .ccg-toolbar, .collection-banner-custom__content, .product-header, .product-details-price, .product-breadcrumbs').forEach(function (element) {
        mark(element, 'fade-up');
      });
      section.querySelectorAll('.ycg-carousel, .ycs-slider, .ypc-carousel, .yarn-features__list, .product-images > *, .product-tabs').forEach(function (element) {
        mark(element, 'fade-up', 50);
      });
      section.querySelectorAll('.ccg-grid > *, .collection-products .product').forEach(function (element, index) {
        mark(element, 'fade-up', (index % 4) * 50);
      });
      if (!section.querySelector('[data-motion-item]')) {
        const surface = section.querySelector('section, .container, .wrap, .inner-container');
        if (surface && !surface.querySelector('[role="dialog"], product-gallery-sticky, .ccg-sidebar')) mark(surface, 'fade-up');
      }
    });
  }

  function syncScrollLock() {
    if (!lenis) return;
    const bodyStyle = getComputedStyle(document.body);
    const locked = document.body.matches('.cart-drawer-open, .modal-active, .no-scroll') || root.classList.contains('ccg-drawer-open') || bodyStyle.overflowY === 'hidden' || bodyStyle.position === 'fixed';
    if (locked && !lenis.isStopped) lenis.stop();
    else if (!locked && lenis.isStopped) lenis.start();
  }

  function setupScroll() {
    if (lenis) lenis.destroy();
    lenis = null;
    if (reducedMotion.matches || editor || typeof window.Lenis !== 'function') return;
    lenis = new window.Lenis({
      autoRaf: true,
      lerp: 0.12,
      smoothWheel: true,
      syncTouch: false,
      anchors: true,
      allowNestedScroll: true,
      prevent: function (node) {
        return node.matches('#cart-drawer, .modal, .ccg-sidebar__panel, textarea, select, [data-lenis-prevent]');
      }
    });
    syncScrollLock();
  }

  function prepareDrawer(drawer) {
    if (!drawer || !window.AOS || reducedMotion.matches || editor) return;
    cancelAnimationFrame(drawerFrame);
    drawer.classList.remove('motion-entered');
    drawer.setAttribute('data-lenis-prevent', '');
    drawer.querySelectorAll(drawerTargets).forEach(function (element, index) {
      element.setAttribute('data-motion-drawer', '');
      element.setAttribute('data-aos', 'fade-left');
      element.style.setProperty('--motion-delay', Math.min(index * 45 + 80, 350) + 'ms');
    });
  }

  function revealDrawer(drawer) {
    if (!drawer) return;
    drawerFrame = requestAnimationFrame(function () {
      drawerFrame = requestAnimationFrame(function () {
        if (drawer.isConnected && drawer.classList.contains('is-open')) drawer.classList.add('motion-entered');
      });
    });
  }

  function refreshDrawer(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.querySelectorAll(drawerTargets).forEach(function (element) {
      if (!element.hasAttribute('data-motion-drawer')) {
        element.setAttribute('data-motion-drawer', '');
        element.setAttribute('data-aos', 'fade-left');
        element.style.setProperty('--motion-delay', '0ms');
      }
    });
  }

  function refresh() {
    cancelAnimationFrame(refreshFrame);
    refreshFrame = requestAnimationFrame(function () {
      if (window.AOS && !editor) {
        prepareSections();
        if (aosReady) window.AOS.refreshHard();
      }
      if (lenis) lenis.resize();
      refreshDrawer(document.getElementById('cart-drawer'));
    });
  }

  window.YarnMotion = {
    prepareDrawer: prepareDrawer,
    revealDrawer: revealDrawer,
    refreshDrawer: refreshDrawer,
    refresh: refresh,
    pause: function () { if (lenis) lenis.stop(); },
    resume: function (position) {
      if (!lenis) return;
      lenis.resize();
      lenis.scrollTo(position, { immediate: true, force: true });
      syncScrollLock();
    }
  };

  function init() {
    setupScroll();
    if (window.AOS && !editor) {
      try {
        prepareSections();
        window.AOS.init({ duration: 600, offset: 40, once: true, mirror: false, easing: 'ease-out-cubic', disableMutationObserver: true });
        aosReady = true;
        root.classList.add('motion-ready');
      } catch (error) {
        root.classList.remove('motion-ready');
      }
    }
    const content = document.getElementById('content');
    if (content) new MutationObserver(refresh).observe(content, { childList: true, subtree: true });
    const lockObserver = new MutationObserver(syncScrollLock);
    lockObserver.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
    lockObserver.observe(root, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('shopify:section:load', refresh);
    document.addEventListener('shopify:section:unload', refresh);
    document.addEventListener('shopify:section:reorder', refresh);
    window.addEventListener('load', refresh);
    window.addEventListener('pageshow', refresh);
    if (document.fonts) document.fonts.ready.then(refresh);
    reducedMotion.addEventListener('change', function () { setupScroll(); refresh(); });
    document.addEventListener('focusin', function (event) {
      const item = event.target.closest('[data-motion-item]');
      if (item) item.classList.add('aos-animate');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
